export const connections = ['zendesk', 'gorgias'];
